export default __webpack_public_path__ + "static/media/paragraphvideo.e047d248.svg";